const getLoading = (state) => state.auth.loading;
export const AuthSelector = {
    getLoading,
};
